import request from '@/utils/request'

//转账记录
export function withdrawTransferList(data) {
    return request({
      url: '/admin/withdrawTransferPol/list',
      method: 'post',
      data: data
    })
  }
  export function totalRecharge(data) {
    return request({
      url: '/admin/tronscanTransfer/totalRecharge',
      method: 'post',
      data: data
    })
  }
  export function tronscanTransferList(data) {
    return request({
      url: '/admin/tronscanTransfer/list',
      method: 'post',
      data: data
    })
  }
// 归集账号管理
export function bnbMasterAccountList(data) {
  return request({
    url: '/admin/polMasterAccount/list',
    method: 'post',
    data: data
  })
}
export function bnbMasterAccountDelete(data) {
  return request({
    url: '/admin/polMasterAccount/delete',
    method: 'post',
    data: data
  })
}
export function bnbMasterAccountSave(data) {
  return request({
    url: '/admin/polMasterAccount/save',
    method: 'post',
    data: data
  })
}
export function bnbMasterAccountUpdate(data) {
  return request({
    url: '/admin/polMasterAccount/update',
    method: 'post',
    data: data
  })
}
export function getById(data) {
  return request({
    url: '/admin/polMasterAccount/getById',
    method: 'post',
    data: data
  })
}
export function genNew(data) {
  return request({
    url: '/admin/polMasterAccount/genNew',
    method: 'post',
    data: data
  })
}
export function importWallet(data) {
  return request({
    url: '/admin/polMasterAccount/importWallet',
    method: 'post',
    data: data
  })
}

// 归集记录
export function tronscanCollectionList(data) {
    return request({
      url: '/admin/polCollectionUsdt/list',
      method: 'post',
      data: data
    })
  }
  export function totalAmount(data) {
    return request({
      url: '/admin/polCollectionUsdt/totalAmount',
      method: 'post',
      data: data
    })
  }
// trx归集记录
export function tronscanCollectionListTrx(data) {
  return request({
    url: '/admin/polCollectionPol/list',
    method: 'post',
    data: data
  })
}
export function totalAmountTrx(data) {
  return request({
    url: '/admin/polCollectionPol/totalAmount',
    method: 'post',
    data: data
  })
}
// 提现转账
export function withdrawTransfer(data) {
    return request({
      url: '/admin/withdrawTransferPol/list',
      method: 'post',
      data: data
    })
  }
  export function autoZhuan(data) {
    return request({
      url: '/admin/withdrawTransferPol/autoZhuan',
      method: 'post',
      data: data
    })
  }
  export function updateAutoZhuan(data) {
    return request({
      url: '/admin/withdrawTransferPol/updateAutoZhuan',
      method: 'post',
      data: data
    })
  }
  export function zhuan(data) {
    return request({
      url: '/admin/withdrawTransferPol/zhuan',
      method: 'post',
      data: data
    })
  }
  export function reject(data) {
    return request({
      url: '/admin/withdrawTransferPol/reject',
      method: 'post',
      data: data
    })
  }
  export function zhuanList(data) {
    return request({
      url: '/admin/withdrawTransferPol/zhuanList',
      method: 'post',
      data: data
    })
  }
  export function masterAccounts(data) {
    return request({
      url: '/admin/withdrawTransferPol/masterAccounts',
      method: 'post',
      data: data
    })
  }
  export function applyCount(data) {
    return request({
      url: '/admin/withdrawTransferPol/applyCount',
      method: 'post',
      data: data
    })
  }
  // 用户资金管理
  export function masterAccountsT(data) {
    return request({
      url: '/admin/memberCollectionPol/masterAccounts',
      method: 'post',
      data: data
    })
  }
  export function collectBnb(data) {
    return request({
      url: '/admin/memberCollectionPol/collectPol',
      method: 'post',
      data: data
    })
  }
  export function collect(data) {
    return request({
      url: '/admin/memberCollectionPol/collect',
      method: 'post',
      data: data
    })
  }
  export function zhuanBnb(data) {
    return request({
      url: '/admin/memberCollectionPol/zhuanPol',
      method: 'post',
      data: data
    })
  }
  export function collectTrx(data) {
    return request({
      url: '/admin/memberCollectionPol/collectTrx',
      method: 'post',
      data: data
    })
  }
  export function delegatedEnergy(data) {
    return request({
      url: '/admin/memberCollectionPol/delegatedEnergy',
      method: 'post',
      data: data
    })
  }
  export function undelegateResource(data) {
    return request({
      url: '/admin/memberCollectionPol/undelegateResource',
      method: 'post',
      data: data
    })
  }
  export function oneCollect(data) {
    return request({
      url: '/admin/memberCollectionPol/oneCollect',
      method: 'post',
      data: data
    })
  }
  export function collectView(data) {
    return request({
      url: '/admin/memberCollectionPol/collectView',
      method: 'post',
      data: data
    })
  }
  export function collectList(data) {
    return request({
      url: '/admin/memberCollectionPol/collectList',
      method: 'post',
      data: data
    })
  }
  export function collectListRemove(data) {
    return request({
      url: '/admin/memberCollectionPol/collectListRemove',
      method: 'post',
      data: data
    })
  }
  export function memberCollectionList(data) {
    return request({
      url: '/admin/memberCollectionPol/list',
      method: 'post',
      data: data
    })
  }



  export function memberPayAdList(data) {
    return request({
      url: '/admin/memberPayAd/list',
      method: 'post',
      data: data
    })
  }
  export function memberPayAdPass(data) {
    return request({
      url: '/admin/memberPayAd/pass',
      method: 'post',
      data: data
    })
  }
  export function memberPayAdReject(data) {
    return request({
      url: '/admin/memberPayAd/reject',
      method: 'post',
      data: data
    })
  }
  export function withdrawTransferTotalAmount(data) {
    return request({
      url: '/admin/withdrawTransferPol/totalAmount',
      method: 'post',
      data: data
    })
  }
  export function tronscanZhuanTotalAmount(data) {
    return request({
      url: '/admin/polZhuanUsdt/totalAmount',
      method: 'post',
      data: data
    })
  }
  export function tronscanZhuanList(data) {
    return request({
      url: '/admin/polZhuanUsdt/list',
      method: 'post',
      data: data
    })
  }
  export function tronscanZhuanExport(data) {
    return request({
      url: '/admin/polZhuanUsdt/export',
      method: 'post',
      data: data
    })
  }
  export function batchFreshUSDT(data) {
    return request({
      url: '/admin/memberCollectionPol/batchFreshAsset',
      method: 'post',
      data
    })
  }
  export function withdrawTransferBnbResetStatus(data) {
    return request({
      url: '/admin/withdrawTransferPol/resetStatus',
      method: 'post',
      data
    })
  }
  export function resetStatus(data) {
    return request({
      url: '/admin/memberCollectionPol/resetStatus',
      method: 'post',
      data
    })
  }
  export function freshUSDT(data) {
    return request({
      url: '/admin/memberCollectionPol/freshAsset',
      method: 'post',
      data
    }) 
  }
  // TRX提现转账
  export function listTex(data) {
    return request({
      url: '/admin/withdrawTransferBnbTrx/list',
      method: 'post',
      data
    })
  }
  export function totalAmountTex(data) {
    return request({
      url: '/admin/withdrawTransferBnbTrx/totalAmount',
      method: 'post',
      data
    })
  }
  export function applyCountTex(data) {
    return request({
      url: '/admin/withdrawTransferBnbTrx/applyCount',
      method: 'post',
      data
    })
  }
  export function updateAutoZhuanTex(data) {
    return request({
      url: '/admin/withdrawTransferBnbTrx/updateAutoZhuan',
      method: 'post',
      data
    })
  }
  export function zhuanTex(data) {
    return request({
      url: '/admin/withdrawTransferBnbTrx/zhuan',
      method: 'post',
      data
    })
  }
  export function rejectTex(data) {
    return request({
      url: '/admin/withdrawTransferBnbTrx/reject',
      method: 'post',
      data
    })
  }
  export function zhuanListTex(data) {
    return request({
      url: '/admin/withdrawTransferBnbTrx/zhuanList',
      method: 'post',
      data
    })
  }
  export function masterAccountsTex(data) {
    return request({
      url: '/admin/withdrawTransferBnbTrx/masterAccounts',
      method: 'post',
      data
    })
  }
  export function autoZhuanTex(data) {
    return request({
      url: '/admin/withdrawTransferBnbTrx/autoZhuan',
      method: 'post',
      data
    })
  }
  // TRX转账记录
  export function tronscanZhuanWithdrawTrxList(data) {
    return request({
      url: '/admin/bnbZhuanUsdtWithdrawTrx/list',
      method: 'post',
      data
    })
  }
  export function tronscanZhuanWithdrawTrxTotalAmount(data) {
    return request({
      url: '/admin/bnbZhuanUsdtWithdrawTrx/totalAmount',
      method: 'post',
      data
    })
  }
  export function tronscanZhuanWithdrawTrxExport(data) {
    return request({
      url: '/admin/bnbZhuanUsdtWithdrawTrx/export',
      method: 'post',
      data
    })
  }
  // 其他币种归集记录
  export function bnbCollectionOtherList(data) {
    return request({
      url: '/admin/polCollectionOther/list',
      method: 'post',
      data
    })
  }
  export function bnbCollectionOtherTotalAmount(data) {
    return request({
      url: '/admin/polCollectionOther/totalAmount',
      method: 'post',
      data
    })
  }
  export function collectOther(data) {
    return request({
      url: '/admin/memberCollectionPol/collectOther',
      method: 'post',
      data
    })
  }
  export function batchFreshAssetOther(data) {
    return request({
      url: '/admin/memberCollectionPol/batchFreshAssetOther',
      method: 'post',
      data
    })
  }
  export function freshAssetOther(data) {
    return request({
      url: '/admin/memberCollectionPol/freshAssetOther',
      method: 'post',
      data
    })
  }
